import { render } from "./ZodiacDuizhao.vue?vue&type=template&id=2c5fa626&scoped=true"
import script from "./ZodiacDuizhao.vue?vue&type=script&lang=js"
export * from "./ZodiacDuizhao.vue?vue&type=script&lang=js"

import "./ZodiacDuizhao.vue?vue&type=style&index=0&id=2c5fa626&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c5fa626"]])

export default __exports__